module.exports = __webpack_public_path__ + "static/media/研发中心.a51ac162.png";